module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-left center"
  }, [_c('div', {
    staticClass: "rotate link--darkpink"
  }, [_c('router-link', {
    attrs: {
      "to": "/hangul-blocks"
    }
  }, [_vm._v("▲"), _c('br'), _vm._v("Hangul Blocks")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate link--darkpink"
  }, [_c('router-link', {
    attrs: {
      "to": "/type-categories"
    }
  }, [_vm._v("Type Categories"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content--first mediumpink"
  }, [_c('div', {
    staticClass: "column--single spacer--medium"
  }, [_c('div', {
    staticClass: "hide-small column--one-fourth"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "column--half center text--blue"
  }, [_c('div', {
    staticClass: "center caption caps column--one-third-static top bold"
  }, [_c('div', {
    class: {
      pointer: true, 'button--toggle': true, 'button--toggle-current': _vm.currentTab === _vm.tabs.korean
    },
    on: {
      "click": function () { return _vm.setTab(_vm.tabs.korean); }
    }
  }, [_vm._v("\n                  Korean\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "center caption caps column--one-third-static top bold"
  }, [_c('div', {
    class: {
      pointer: true, 'button--toggle': true, 'button--toggle-current': _vm.currentTab === _vm.tabs.all
    },
    on: {
      "click": function () { return _vm.setTab(_vm.tabs.all); }
    }
  }, [_vm._v("\n                    Both\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "center caption caps column--one-third-static top bold"
  }, [_c('div', {
    class: {
      pointer: true, 'button--toggle': true, 'button--toggle-current': _vm.currentTab === _vm.tabs.english
    },
    on: {
      "click": function () { return _vm.setTab(_vm.tabs.english); }
    }
  }, [_vm._v("\n                    English\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide-small column--one-fourth"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1,
        stickyTop: 0
      }),
      expression: "{ zIndex: 1, stickyTop: 0 }"
    }],
    staticClass: "sticky mediumpink"
  }, [_c('letter-form-scroll', {
    attrs: {
      "current-tab": _vm.currentTab,
      "tabs": _vm.tabs
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content lightpink"
  }, [_c('div', {
    staticClass: "spacer--medium"
  }), _vm._v(" "), _c('letter-form-toggle', {
    attrs: {
      "current-tab": _vm.currentTab,
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center"
  }, [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/type-categories"
    }
  }, [_vm._v("Next Chapter")])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title caps rotate"
  }, [_vm._v("\n          The Basics\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("1–3")]), _vm._v(" "), _c('h1', [_vm._v("Letter-form Anatomy")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("What are parts of letters called? Some parts exist in both the English and Korean alphabet—some don’t.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-855e042c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LetterFormAnatomy.vue
// module id = 152
// module chunks = 0